import React, { Component } from "react";
import { connect } from "react-redux";
import { string, instanceOf } from "prop-types";
import "./style.css";
import ButtonBack from "../ButtonBack";
import passportExample from "../../assets/passport-example.png";
import idCardExample from "../../assets/id-card-front.jpg";
import idCardBackExample from "../../assets/id-card-back.jpg";
import drivingLicenceExample from "../../assets/driving-licence-front.jpg";
import drivingLicenceExampleBack from "../../assets/driving-licence-back.jpg";
import icoScan from "../../assets/icons/XL/Ico-scan.svg";
import PageContent from "../PageContent";
import { Modal } from "react-bootstrap";
// import Dropdown from "react-dropdown";

import {
  ID_CARD,
  DRIVERS_LICENCE,
  OTHER_DOCUMENT,
} from "../../logic/enums/documentType";
import { go } from "../../logic/actions/navigation";
import { isMobile } from "../../logic/deviceType";
import {
  createInstance,
  isSinglePaged,
  modalShowed,
  documentCaptureConfig,
} from "../../logic/actions/documentCapture";
import { INSTRUCTION_VIDEO_DOCUMENT } from "../../logic/enums/pages";
import LinkNativeCapture from "../LinkNativeCapture";
import Icon from "../Icon";
import RoundIcon from "../RoundIcon";
import { preview } from "../../logic/actions/documentCapture";
// import { width, height } from "../../logic/documentResolution";
import { NATIVE } from "../../logic/enums/captureTypes";
import "react-dropdown/style.css";
import { toggleNetworkWarnings } from "../../logic/actions/apiFetch";
import { timeout } from "../../logic/documentCaptureConfiguration";
import { CONNECTION_ISSUES } from "../../logic/enums/errorMessages";

// const standardResolutions = ["720p", "1440p"];
// const standardResolutions = ["720p", "1080p", "1440p", "4k"];
// const captureConfig = ["1 Frame", "3 Frames", "5 Frames"];

const START = 0;
const PASS = 2;

function contentByType(type, base64CroppedFirstPage) {
  const instructionTxt = isMobile(navigator.userAgent)
    ? "Take a photo"
    : "Upload a photo";
  switch (type) {
    case ID_CARD:
      if (!base64CroppedFirstPage)
        return {
          heading: "ID card photo page",
          description: instructionTxt + " of your ID card photo page.",
          exampleImage: idCardExample,
        };
      else
        return {
          heading: "ID card back",
          description: instructionTxt + " of the back of your ID card.",
          exampleImage: idCardBackExample,
        };
    case DRIVERS_LICENCE:
      if (!base64CroppedFirstPage)
        return {
          heading: "Drivers licence photo page",
          description: instructionTxt + " of your drives licence photo page.",
          exampleImage: drivingLicenceExample,
        };
      else
        return {
          heading: "Drivers licence back",
          description: instructionTxt + " of the back of the drivers licence.",
          exampleImage: drivingLicenceExampleBack,
        };
    case OTHER_DOCUMENT:
      if (!base64CroppedFirstPage)
        return {
          heading: "Your document photo page",
          description: instructionTxt + " of your document photo page.",
          exampleImage: idCardExample,
        };
      else
        return {
          heading: "ID card back",
          description: instructionTxt + " of the back of your document.",
          exampleImage: idCardBackExample,
        };
    default:
      return {
        heading: "Passport photo page",
        description: instructionTxt + " of your passport photo page.",
        exampleImage: passportExample,
      };
  }
}

export class PageDocumentCaptureInstructions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dc: undefined,
      pending: false,
      message: "",
      formState: START,
      shouldStartNativeCamera: false,
      width: 2560,
      height: 1440,
    };

    if (this.props.documentCapture) {
      const { documentQualityHostname } = this.props.configuration;
      const url = documentQualityHostname + "/rest/v1/quality/assessments";
      this.initDocumentCaptureSDK(
        url,
        this.state.width,
        this.state.height,
        this.props.documentCapture.documentType
      );
    }
  }

  static propTypes = {
    documentType: string,
    base64CroppedFirstPage: instanceOf(Blob),
    configuration: instanceOf(Object),
    documentCapture: instanceOf(Object),
  };

  componentDidMount() {
    if (
      !this.props.documentCapture.base64CroppedFirstPage &&
      this.props.documentCapture.documentType !== "PASSPORT"
    ) {
      this.setState({ hintFacePresent: true });
      this.documentPagesNum(this.props.documentCapture.documentType);
    }
  }

  initDocumentCaptureSDK = (url, width, height, documentType) => {
    if (true) {
      const config = {
        url,
        width,
        height,
        captureType: "PORTRAIT",
        documentType: documentType === "PASSPORT" ? documentType : "ID_CARD",
      };
      this.props.createInstance(config);
    }
    // else if (
    //   this.props.documentCapture.docCaptureInstance.config.documentType !==
    //   documentType
    // ) {
    //   this.props.documentCapture.docCaptureInstance.config.documentType =
    //     documentType === "PASSPORT" ? documentType : "ID_CARD";
    // }
  };

  handleShowNativeInstructions = () => {
    this.props.modalShowed();
    this.setState({ nativeInstructions: true });
    if (this.props.documentCapture.count >= 1) {
      this.handleCloseNativeInstructions();
    }
  };

  handleCloseNativeInstructions = () => {
    this.setState({ nativeInstructions: false });
    this.state.shouldStartNativeCamera
      ? this.setState({ shouldStartNativeCamera: false })
      : this.setState({ shouldStartNativeCamera: true });
  };

  captureFeedback(response, calledFrom) {
    if (this.state.formState === PASS) return;

    this.setState({
      pending: false,
      blobPreview: undefined,
      isNetworkError: false,
    });

    if (response.result === "PASS") {
      this.setState({
        message: "",
        formState: PASS,
      });

      this.props.preview({
        blob: response.sentBlobImage,
        base64: response.responseBase64Image,
      });
    } else {
      this.setState({
        message:
          response.feedback || !response.message.includes("aborted")
            ? response.feedback || response.message
            : CONNECTION_ISSUES,
        formState: START,
      });
    }
  }

  captureError(err, calledFrom) {
    if (this.state.formState === PASS) return;
    this.setState({
      pending: false,
      formState: START,
      blobPreview: undefined,
      message: CONNECTION_ISSUES,
      isNetworkError: true,
    });
  }

  nativeCapture = (blob) => {
    this.setState({ captureMethod: NATIVE, pending: true, formState: START });
    this.props.toggleNetworkWarnings(true);
    this.props.documentCapture.docCaptureInstance
      .assessQuality({
        blob,
        hintFacePresent: this.state.hintFacePresent,
        timeout: this.props.timeout || timeout,
      })
      .then((response) => this.captureFeedback(response, NATIVE))
      .catch((error) => this.captureError(error, NATIVE))
      .finally(() => this.props.toggleNetworkWarnings(false));
  };

  documentPagesNum = (type) => {
    switch (type) {
      case ID_CARD:
        if (this.props.documentCapture.docCountryOptions.id === 1) {
          this.props.isSinglePaged(true);
        } else {
          this.props.isSinglePaged(false);
        }
        break;
      case DRIVERS_LICENCE:
        if (this.props.documentCapture.docCountryOptions.dl === 1) {
          this.props.isSinglePaged(true);
        } else {
          this.props.isSinglePaged(false);
        }
        break;
      default:
        this.props.isSinglePaged(false);
    }
  };

  // reinitDocumentSDK = (e) => {
  //   const { documentQualityHostname } = this.props.configuration;
  //   const url = documentQualityHostname + "/rest/v1/quality/assessments";

  //   switch (e.value) {
  //     case "720p":
  //       this.initDocumentCaptureSDK(
  //         url,
  //         1280,
  //         720,
  //         this.props.documentCapture.documentType
  //       );
  //       break;
  //     case "1080p":
  //       this.initDocumentCaptureSDK(
  //         url,
  //         1920,
  //         1080,
  //         this.props.documentCapture.documentType
  //       );
  //       break;
  //     case "1440p":
  //       this.initDocumentCaptureSDK(
  //         url,
  //         2560,
  //         1440,
  //         this.props.documentCapture.documentType
  //       );
  //       break;
  //     case "4k":
  //       this.initDocumentCaptureSDK(
  //         url,
  //         3840,
  //         2160,
  //         this.props.documentCapture.documentType
  //       );
  //       break;
  //     default:
  //       this.initDocumentCaptureSDK(
  //         url,
  //         1280,
  //         720,
  //         this.props.documentCapture.documentType
  //       );
  //   }
  // };

  // captureConfigOptions = (e) => {
  //   switch (e.value) {
  //     case "1 Frame":
  //       this.props.documentCaptureConfig({
  //         numOfFrames: 1,
  //         initialCaptureDelay: 1500,
  //         captureInterval: 0,
  //       });
  //       break;
  //     case "3 Frames":
  //       this.props.documentCaptureConfig({
  //         numOfFrames: 3,
  //         initialCaptureDelay: 1000,
  //         captureInterval: 700,
  //       });
  //       break;
  //     case "5 Frames":
  //       this.props.documentCaptureConfig({
  //         numOfFrames: 5,
  //         initialCaptureDelay: 1000,
  //         captureInterval: 400,
  //       });
  //       break;
  //     default:
  //       this.props.documentCaptureConfig({
  //         numOfFrames: 1,
  //         initialCaptureDelay: 1500,
  //         captureInterval: 0,
  //       });
  //       break;
  //   }
  // };

  componentWillUnmount() {
    this.props.documentCapture.docCaptureInstance.clearCapturedFrames();
  }

  render() {
    const { heading, description, exampleImage } = contentByType(
      this.props.documentCapture.documentType,
      this.props.documentCapture.base64CroppedFirstPage
    );
    return (
      <PageContent
        toggleLoading={this.state.pending}
        progressBar={true}
        progressPercentage={70}
      >
        <Modal
          show={
            this.state.nativeInstructions &&
            this.props.documentCapture.count < 2
          }
          onHide={this.handleCloseNativeInstructions}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <p>
                <strong>
                  Please make sure you can see your document fully, positioned
                  in the center of the screen.
                </strong>
              </p>
            </Modal.Title>
          </Modal.Header>
        </Modal>
        {!this.props.documentCapture.base64CroppedFirstPage ? (
          <header>
            <ButtonBack to="/PageVerifyIdentity" />
          </header>
        ) : null}
        <h1>{heading}</h1>
        <img
          className="icon-passport-example"
          src={icoScan}
          alt="doc capture icon"
        />
        <p className="center">{description}</p>

        <div className="panel border-gray bg-row">
          <div className="margin-h-auto">
            <img
              src={exampleImage}
              alt="document example"
              className="img-document-example"
            />
            <p className="center">
              This is how your photo should look - taken on a clear background,
              well lit and without glare
            </p>
          </div>
        </div>
        {this.state.message ? (
          <div>
            <div className="panel bg-red flex-row">
              <RoundIcon color="red">
                <Icon name="Rejected" color="white" />
              </RoundIcon>
              <div className="panel-content">
                <p>{this.state.message}</p>
              </div>
            </div>
          </div>
        ) : null}

        {isMobile(navigator.userAgent) ? (
          this.props.documentCapture.base64CroppedFirstPage ||
          this.props.documentCapture.base64CroppedFirstPage ||
          this.props.documentCapture.documentType === "PASSPORT" ||
          this.props.documentCapture.docCountryOptions.id ||
          this.props.documentCapture.docCountryOptions.dl ? (
            <button
              className="btn blue"
              onClick={() => {
                this.props.go(INSTRUCTION_VIDEO_DOCUMENT);
              }}
            >
              Take a photo
            </button>
          ) : (
            <div>
              <button
                className="btn green"
                onClick={() => {
                  this.props.go(INSTRUCTION_VIDEO_DOCUMENT);
                }}
              >
                Capture two-sided document
              </button>
              <button
                className="btn blue"
                onClick={() => {
                  this.props.isSinglePaged(true);
                  this.props.go(INSTRUCTION_VIDEO_DOCUMENT);
                }}
              >
                Capture one-sided document
              </button>
            </div>
          )
        ) : (
          <div>
            <LinkNativeCapture
              class={"btn green"}
              onClick={this.onCaptureClick}
              onUploaded={this.nativeCapture}
              facingMode="environment"
              handleShowNativeInstructions={this.handleShowNativeInstructions}
              shouldStartNativeCamera={this.state.shouldStartNativeCamera}
            />
            {this.props.documentCapture.base64CroppedFirstPage ||
            this.props.documentCapture.docCountryOptions.id ||
            this.props.documentCapture.documentType === "PASSPORT" ||
            this.props.documentCapture.docCountryOptions.dl ? (
              <button
                className="btn white"
                onClick={() => {
                  this.props.go(INSTRUCTION_VIDEO_DOCUMENT);
                }}
              >
                Take a photo
              </button>
            ) : (
              <div>
                <button
                  className="btn blue"
                  onClick={() => {
                    this.props.go(INSTRUCTION_VIDEO_DOCUMENT);
                  }}
                >
                  Capture two-sided document
                </button>
                <button
                  className="btn white"
                  onClick={() => {
                    this.props.isSinglePaged(true);
                    this.props.go(INSTRUCTION_VIDEO_DOCUMENT);
                  }}
                >
                  Capture one-sided document
                </button>
              </div>
            )}
          </div>
        )}
        {/* <Dropdown
          onChange={this.reinitDocumentSDK}
          options={standardResolutions}
          value={standardResolutions[0]}
        /> */}
        {/* <Dropdown
          onChange={this.captureConfigOptions}
          options={captureConfig}
          value={captureConfig[0]}
        /> */}
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    return {
      documentCapture: state.documentCapture,
      configuration: state.configuration,
      lockUI: state.configuration.extraConfig.featureFlags.lockUI,
      timeout: state.configuration.extraConfig.featureFlags.timeout,
    };
  },
  {
    go,
    createInstance,
    preview,
    isSinglePaged,
    modalShowed,
    documentCaptureConfig,
    toggleNetworkWarnings
  }
)(PageDocumentCaptureInstructions);
